const genericErrorMessage = 'An error occurred. Please try again later.';
import { PALMETTO_LOGO_BASE64 } from './palmetto-logo';

const pageOptions: SelectOptions[] = [
  { label: '5', value: '5' },
  { label: '10', value: '10' },
  { label: '15', value: '15' },
  { label: '20', value: '20' },
];

const contactSubjectOptions: SelectOptions[] = [
  { label: 'Report a bug', value: 'report_bug' },
  { label: 'Suggestion/improvements', value: 'suggestion' },
  { label: 'Technical support', value: 'tech_support' },
];

export { contactSubjectOptions, genericErrorMessage, pageOptions, PALMETTO_LOGO_BASE64 };
